import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//helpers:
import { getData, postData } from '../../dataLib';

//actions:
import { modifyDatosCierreDiario, getArtMktCentro } from '../../actions/cierre_diario_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions/index';

//components:
import NeuriteGrid from '../../components/neurite_grid';
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';


//grid de datos de facturas de MKT
//solo trabaja con state local ya que ningun otro control depende de estos datos
//y hace todas las modificaciones directamente en la DB cuando se hace click en OK

const styles = theme => ({
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    divData: {
        position: 'relative'
    },
    cover: {
        position: 'absolute',
        height: 300,
        width: '100%',
        marginLeft: 8,
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },

});

class CierreDiarioMKTGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mkt: [],
            total: 0.0,
            showSpinner: true,
            saveDisabled: true
        };
    };

    componentDidUpdate(prevProps) {
        if (this.producto === undefined &&
            prevProps.centroDiaSelected !== this.props.centroDiaSelected) {
            this.getMkt();
            this.props.getArtMktCentro(this.props.centroDiaSelected.centro.id);
        }

        if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro)
            this.setState({ ...this.state, showSpinner: true })
    };

    messageError = error => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, 'error_cierre_diario_mkt_grid', false, 'sm');

    };

    checkValues = (factura) => {
        if (!factura.fechaFra) {
            this.messageError('Por favor, defina una fecha');
            return false;
        } else if (!factura.factura) {
            this.messageError('Por favor, defina un número de factura');
            return false;
        } else if (!factura.cliente) {
            this.messageError('Por favor, defina un cliente');
            return false;
        } else if (!factura.importe) {
            this.messageError('Por favor, defina un importe');
            return false;
        }

        return true;
    };

    modifyFactura = (factura) => {
        var rows = this.state.mkt.map((row) => {
            if (row.id === factura.id) return factura;
            else return row;
        });
        this.props.setSaveState(true);
        this.setState({ ...this.state, mkt: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    editFactura = (factura) => {
        this.props.openDialog('EditMktGrid', {
            factura: factura,
            producto: this.props.producto,
            zonas: this.props.artMKT,
            okHandler: this.modifyFactura,
            checkValues: this.checkValues,
            usuario: this.props.user ? this.props.user.profile.sub : 0,
            fecha: this.props.centroDiaSelected.dia
        }, 'edit_mkt_grid_dialog');
    };

    addFactura = (factura) => {
        let rows = this.state.mkt.slice();
        rows.push(factura);
        this.props.setSaveState(true);
        this.setState({ ...this.state, mkt: rows, total: this.calculateTotal(rows), saveDisabled: false  });
    };

    newFactura = () => {
        this.props.openDialog('EditMktGrid', {
            factura: {
                articuloId: this.props.producto ? this.props.producto.articuloId : '',
                tipoZona: this.props.producto ? this.props.artMKT.find(tz => tz.id === this.props.producto.articuloId).descr : ''
            },
            producto: this.props.producto,
            zonas: this.props.artMKT,
            okHandler: this.addFactura,
            checkValues: this.checkValues,
            usuario: this.props.user ? this.props.user.profile.sub : 0,
            fecha: this.props.centroDiaSelected.dia
        }, 'new_mkt_grid_dialog');
    };


    deleteFactura = (factura) => {
        let rows = this.state.mkt.filter(f => f.id !== factura.id);
        this.props.setSaveState(true);
        this.setState({ ...this.state, mkt: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    checkCaja = (caja) => {
        if (this.props.cajasCentro.find(c => (c.descr === caja.descr) && (c.id !== caja.id))) {
            return false;
        };
        return true;
    };

    calculateTotal = (rows) => {
        let total = 0.0;
        rows.forEach((r) => {
            total += parseFloat(r.importe);
        });

        return total;
    };

    //obtiene las facturas de MKT
    getMkt = () => {

        let mktURL = 'VMkt?date=' + this.props.centroDiaSelected.dia;

        if (this.props.producto !== undefined) mktURL += '&articulo_id=' + this.props.producto.articuloId;
        else mktURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        getData(mktURL,
            (response) => {
                this.setState({ ...this.state, mkt: response.data, total: this.calculateTotal(response.data), showSpinner: false })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching mkt'
                }, 'error_get_mkt', false, 'sm');
            },
            this.props.user
        );
    };

    //hace un update de MKT, muestra un mensaje y actualiza el store (datos cierre diario) con el valor de label del botón 1 para este control (total de las facturas introducidas)
    updateMKt = () => {

        this.setState({ ...this.state, saveDisabled: true });

        var facturas = this.state.mkt.slice();
        facturas.forEach((f) => {
            if (typeof f.id !== 'number') f.id = -1;
        });

        let mktURL = 'VMkt/facturas?date=' + this.props.centroDiaSelected.dia;
        if (this.props.producto !== undefined) mktURL += '&articulo_id=' + this.props.producto.articuloId;
        else mktURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        postData(mktURL,
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'mkt actualizados'
                }, 'update_mkt_success_dialog', false, 'sm');
                this.props.setSaveState(false);
                if (this.props.producto !== undefined) this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: this.state.total, button1: this.state.total })
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating mkt'
                }, 'update_mkt_error_dialog', false, 'sm');
            },
            facturas,
            this.props.user
        );


    };

    componentDidMount = () => {
        this.getMkt();
        this.props.getArtMktCentro(this.props.centroDiaSelected.centro.id);
    };

    deshacer = () => {
        this.setState({ ...this.state, showSpinner: true })
        this.getMkt();
    }

    render() {
        const { classes } = this.props;

        if (this.state.showSpinner)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            );

        return (
            <div className={classes.divData}>
                <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>
                <NeuriteGrid
                    id="c_d_m_g"
                    columns={[
                        //{ key: 'id', name: 'id', editable: false, dragable: false },
                        { key: 'tipoZona', name: 'Zona', tooltip: 'Zona en que se imputa el cobro', editable: false, dragable: false, width: 100 },
                        { key: 'fechaFra', name: 'Fecha Factura', tooltip: 'Fecha de la factura del cliente', editable: false, dragable: false, type: 'date', width: 100 },
                        { key: 'factura', name: 'Factura', tooltip: 'Número de factura del cliente', editable: false, dragable: false, width: 90 },
                        { key: 'cliente', name: 'Cliente', editable: false, dragable: false, width: 400 },
                        { key: 'importe', name: 'Importe', editable: false, dragable: false, type: 'float', width: 70 },
                        { key: 'cobrada', name: 'Cobrada', tooltip: 'Indica si ha sido cobrada en el centro', editable: false, dragable: false, type: 'bool', width: 70 }
                    ]}
                    rows={this.state.mkt}
                    height={300}
                    buttonEdit={!this.props.isDiaCerrado}
                    buttonDelete={!this.props.isDiaCerrado}
                    buttonNew={!this.props.isDiaCerrado && this.props.centroDiaSelected.isValid}
                    onNewRowClick={this.newFactura}
                    onEditClick={this.editFactura}
                    onDeleteClick={this.deleteFactura}
                />

                <div className={classes.total}>
                    <p style={{ margin: 0 }}>Total</p>

                    <TextField
                        id="total"
                        disabled
                        value={this.state.total}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />
                </div>

                <div className={classes.bottomBtn}>
                    {this.props.isDialog ?
                        <Button variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                        :
                        <Button hidden={this.props.isDiaCerrado} variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.deshacer() }}>Deshacer</Button>
                    }
                    {!this.props.isDiaCerrado ? <Button variant="contained" color="primary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid || this.state.saveDisabled} onClick={() => { this.updateMKt() }}>Guardar</Button> : ''}
                </div>
            </div>
        );
    };
};


CierreDiarioMKTGrid.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    user: PropTypes.object,
    artMKT: PropTypes.array.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
    //dispatch
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    getArtMktCentro: PropTypes.func.isRequired,
    //parameters
    producto: PropTypes.object

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        artMKT: state.artMKT,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyDatosCierreDiario,
        hideDialog,
        openDialog,
        getArtMktCentro,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioMKTGrid));